module.exports = __webpack_public_path__ + "img/usuario__disable.d77bde2f.svg";